import React,{ useEffect ,useState} from "react";
import { languageOptions } from "../../utils/constants";
import { debounce, debouncePromise } from "../../utils/Debounce";
import api from "../../services/api";
import { ScrollContainer } from 'react-indiana-drag-scroll';
import TableLoader from '../../shared/TableLoader';
import NoDataFound from '../../shared/NoDataFound';
import Select from "react-select";
import { Toast } from "../../shared/Toast";

const BrandLocations = ()=>{
    const [selectedDistricts, setSelectedDistricts] = useState({});
    const [district,setdistricts] = useState([])
    const [data,setdata]=useState([]);
    const [loader,setloader]=useState(false);
    const [showEdit, setShowEdit] = useState({});

    const [selectedLocations, setSelectedLocations] = useState([]);
    const [showMergeModal, setShowMergeModal] = useState(false);
    const [correctLocation, setCorrectLocation] = useState(null);
    const [filterlocation,setfilterlocation] = useState(null)

    const getDistricts = async()=>{
        const lang_ids = languageOptions
            .filter(lang => lang.label === "Telugu")
            .map(lang => lang.value);
        try {
            const res = await api({ url: `/birdview/getDistrictsByLang`, method: "POST", data: {lang_ids} });
            if (res.code === 200) setdistricts(res.data);
          } catch (error) {}
    }
    const getLocations = async()=>{
        try {
            const res = await api({ url: `/birdview/getBrandLocations`, method: "POST", data: {location:filterlocation} });
            if (res.code === 200) setdata(res.data);
          } catch (error) {}
    }
    const changeDistrict = (option, idx) => {
      setSelectedDistricts((prev) => ({
        ...prev,
        [idx]: option,   
      }));
    };
    const openMergeModal = () => {
      if (selectedLocations.length === 0) {
        Toast("error", "Please select at least 1 location to merge");
        return;
      }
      setShowMergeModal(true);
    };
    const mergeLocations = async () => {
      if (!correctLocation || correctLocation.trim() === '') {
        Toast("error", "Please select the correct location");
        return;
      }
      if (loader) return;
      setloader(true);
      try {
        const res = await api({
          url: `/birdview/mergeBrandLocations`,
          method: "POST",
          data: {
            locationsMerge: selectedLocations,
            correctLocation: correctLocation,
          }
        });
        if (res.code === 200) {
          Toast("success", "Locations Merged Successfully");
          getLocations();
          setSelectedLocations([]);
          setCorrectLocation(null);
          setShowMergeModal(false);
        }
        setloader(false);
      } catch (error) {
        setloader(false);
      }
    };
    const handleCheckboxChange = (location) => {
      setSelectedLocations((prev) => {
        if (prev.includes(location)) {
          return prev.filter((loc) => loc !== location);
        } else {
          return [...prev, location];
        }
      });
    };
    const addDistrict = async(location,districts)=>{
      if(loader)
        return;
      if(!districts)
      {
         Toast("error","Select District")
         return;
      }
      setloader(true);
      try {
        const res = await api(
          { url: `/birdview/addBrandDistrict`, method: "POST", 
            data: {brand_location:location,district_id:districts?.dist_id,dist_name:districts?.dist_name} 
          });
        if (res.code === 200){
          Toast('success',"District Mapped Successfully");
          getLocations();
          setSelectedDistricts({});
        }
        else
        {
          Toast('error',res.data?.message || "Failed to Merge")
        }
        setloader(false);
      } catch (error) {setloader(false)}
    }
    const editDistrict = async(bl_id,districts)=>{
      if(!districts)
      {
        Toast("error","Select District")
        return;
      }
      if(loader)
        return;
      setloader(true);
      try {
        const res = await api(
          { url: `/birdview/editBrandDistrict`, method: "POST", 
            data: {bl_id,district_id:districts?.dist_id,dist_name:districts?.dist_name} 
          });
        if (res.code === 200){
          Toast('success',"District Mapped Successfully");
          getLocations();
          setSelectedDistricts({});
          setShowEdit({});
        }
        setloader(false);
      } catch (error) {setloader(false)};
    }
    useEffect(()=>{
      getDistricts();
      getLocations();
    },[])
    useEffect(()=>{
      debouncePromise(getLocations(), 500);
    },[filterlocation])
    return(
  <div className="m-4">
   <div className="flex justify-between items-center gap-4 mb-4">
      <div className="flex-1">
        <input
          type="text"
          placeholder="Search Brand location"
          value={filterlocation || ''}
          onChange={(e) => setfilterlocation(e.target.value)}
          className="w-400px px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
      </div>
      {selectedLocations.length > 0 && (
        <div className="flex justify-items-end sticky top-0 z-10 mb-4" >
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
            onClick={openMergeModal}
          >
            Merge Selected ({selectedLocations.length})
          </button>
        </div>
      )}
   </div>
      <table className="table table-bordered">
        <thead>
          <tr className="bg-gray-100">
            <th>Select</th>
            <th>Brand Location</th>
            <th>Brand District</th>
            <th>Action</th>
          </tr>
        </thead>

        {data?.length && !loader ? (
        <tbody>
            {data.map((row, idx) => (
              <tr key={idx} className="border-t">
                <td>
                  <input
                    type="checkbox"
                    checked={selectedLocations.includes(row.brand_location)}
                    onChange={() => handleCheckboxChange(row.brand_location)}
                    className="w-4 h-4"
                  />
                </td>
                <td>{row.brand_location}</td>
                <td>
                  {row.district_id ? (
                    <>
                        <span>{row.dist_name}</span>
                        <sl-icon-button
                            library="lucide"
                            name="edit"
                            onClick={() => {
                              setShowEdit((prev) => ({
                                ...prev,
                                [idx]: !prev[idx],
                              }));
                            }}
                          ></sl-icon-button>

                        {showEdit[idx] && district.length > 0 && (
                      <Select
                        aria-label="Default select example"
                        placeholder="Select District"
                        value={selectedDistricts[idx] || null}
                        onChange={(option) => changeDistrict(option, idx)}
                        options={district}
                        getOptionLabel={(option) => option.dist_name}
                        getOptionValue={(option) => option.dist_id}
                        isClearable
                      />)}
                    </>
                  ) : (
                    district.length > 0 && (
                      <Select
                        aria-label="Default select example"
                        placeholder="Select District"
                        value={selectedDistricts[idx] || null}   // only for this row
                        onChange={(option) => changeDistrict(option, idx)}
                        options={district}
                        getOptionLabel={(option) => option.dist_name}
                        getOptionValue={(option) => option.dist_id}
                        isClearable
                      />
                    )
                  )}
                </td>
                <td>
                  {row.district_id == null ? (
                    <button
                      className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 transition-colors"
                      onClick={() => addDistrict(row.brand_location, selectedDistricts[idx])}
                    >
                      Add
                    </button>
                  ): showEdit[idx] && <button className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
                      onClick={()=>editDistrict(row.bl_id,selectedDistricts[idx])}>
                      Edit  
                      </button>}
                </td>
              </tr>
          ))}
        </tbody>
          ) : !data.length && !loader ? (
            <NoDataFound colspan="10" />
          ) : (
            <TableLoader colspan="10" />
          )}
      </table>
    {showMergeModal && (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-full">
        <h3 className="text-lg font-semibold mb-4">Merge Locations</h3>
        
        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">Selected Locations:</label>
          <ul className="list-disc pl-5 mb-3 max-h-40 overflow-y-auto">
            {selectedLocations.map((loc, idx) => (
              <li key={idx} className="text-sm">{loc}</li>
            ))}
          </ul>
        </div>

        <div className="mb-4">
            <label className="block text-sm font-medium mb-2">Correct Location:</label>
            <input
              type="text"
              placeholder="Type the correct location"
              value={correctLocation || ''}
              onChange={(e) => setCorrectLocation(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
        </div>

        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
            onClick={() => {
              setShowMergeModal(false);
              setCorrectLocation(null);
            }}
          >
            Cancel
          </button>
          <button
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition-colors"
            onClick={mergeLocations}
          >
            Merge
          </button>
        </div>
      </div>
    </div>
   )}
  </div>
    )
}
export default BrandLocations;